import { Square, SquareCheck } from "lucide-react";
import React from "react";

interface CheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  label?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onCheckedChange,
  disabled = false,
  className = "",
}) => {
  return (
    <div
      className={`flex items-center p-1 rounded ${
        disabled ? "cursor-default opacity-50" : "cursor-pointer"
      } w-full ${className}`}
      onClick={() => !disabled && onCheckedChange(!checked)}
    >
      <div className="flex-shrink-0 min-w-[24px]">
        {checked ? (
          <SquareCheck className="w-6 h-6 text-[#5C88C5]" />
        ) : (
          <Square className="w-6 h-6 text-[#354052]" />
        )}
      </div>
      <label
        htmlFor="select-all"
        className={`ml-2 text-[#354052] text-[14px] cursor-pointer ${
          disabled ? "cursor-default opacity-50" : ""
        }`}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
